import { render, staticRenderFns } from "./ResolvedFalg.vue?vue&type=template&id=b35d587e&"
import script from "./ResolvedFalg.vue?vue&type=script&lang=js&"
export * from "./ResolvedFalg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports